import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import emailjs from "@emailjs/browser";

function ServiceDetailPage() {
  const { slug } = useParams();
  const [service, setService] = useState(null);
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch("/image_json/services_meta.json")
      .then((res) => res.json())
      .then((metaData) => {
        const meta = metaData[slug];
        if (meta) {
          setService({
            id: slug,
            title: meta.title || slug,
            full_desc: meta.full_desc || "",
            icon: meta.icon || "🔧",
            image_json: meta.image_json || `/image_json/${slug}.json`,
            reviews: meta.reviews || [],
          });
        } else {
          console.warn("Slug eşleşmedi:", slug);
        }
      })
      .catch((err) => console.error("Hizmet verisi yüklenemedi:", err));
  }, [slug]);

  useEffect(() => {
    if (!service?.image_json) return;

    const imagePath = `/${service.image_json}`.replace(/^\/+/, '/');
    fetch(imagePath)
      .then((res) => {
        const contentType = res.headers.get("content-type");
        if (!res.ok || !contentType?.includes("application/json")) {
          throw new Error(`Yanıt JSON değil: ${contentType}`);
        }
        return res.json();
      })
      .then((data) => setImages(data))
      .catch((err) => console.error("Görseller yüklenemedi:", err));
  }, [service]);

  if (!service) {
    return <p className="text-center py-20">Hizmet bilgisi yüklenemedi. Lütfen daha sonra tekrar deneyin.</p>;
  }

  return (
    <div className="bg-gray-50 min-h-screen text-gray-800">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white shadow-md px-6 py-4 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2">
          <img src="/logo.png" alt="Logo" className="h-8" />
          <div className="flex flex-col">
            <span className="text-lg font-bold">Ankara Elektrik Uzmanı</span>
            <span className="text-sm text-gray-600">Klima & Elektrik Hizmetleri</span>
          </div>
        </a>
        <a href="tel:05513683020" className="text-blue-600 hover:underline font-medium">
          📞 0551 368 30 20
        </a>
      </header>

      {/* Hizmet Başlığı */}
      <section className="bg-blue-600 text-white px-6 py-8 text-center">
        <h2 className="text-3xl font-bold mb-2">{service.icon} {service.title}</h2>
        <p className="text-blue-100 max-w-2xl mx-auto mb-4">{service.full_desc}</p>
        <div className="flex justify-center gap-4">
          <a href="tel:05513683020" className="bg-white text-blue-600 px-4 py-2 rounded shadow hover:bg-blue-100">📞 Hemen Ara</a>
          <a href="https://wa.me/905513683020" target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white px-4 py-2 rounded shadow hover:bg-green-600">💬 WhatsApp</a>
        </div>
      </section>

      {/* Galeri */}
      <section className="px-6 py-8">
        <h3 className="text-xl font-semibold mb-4">Bitirilen Projeler</h3>
        <div className="overflow-x-auto">
          <div className="flex gap-4">
            {images.map((img, index) => (
              <img
                key={index}
                src={img.url}
                alt={img.title || `Proje ${index + 1}`}
                className="h-48 rounded shadow-sm hover:scale-105 transition-transform"
              />
            ))}
          </div>
        </div>
      </section>

      {/* Müşteri Yorumları */}
      {service.reviews.length > 0 && (
        <section className="px-6 py-8 bg-white">
          <h3 className="text-xl font-bold mb-6 text-center text-gray-800">Müşteri Yorumları</h3>
          <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {service.reviews.map((review, index) => (
              <div key={index} className="border border-gray-200 rounded-lg shadow-sm p-6 bg-gray-50">
                <div className="flex items-center mb-4">
                  <div className="bg-blue-600 text-white rounded-full w-10 h-10 flex items-center justify-center text-lg font-bold">
                    {review.name.charAt(0)}
                  </div>
                  <div className="ml-3">
                    <p className="font-semibold text-gray-800">{review.name}</p>
                    <p className="text-yellow-500 text-sm">
                      {"★".repeat(review.rating)}{"☆".repeat(5 - review.rating)}
                    </p>
                  </div>
                </div>
                <p className="text-gray-700 text-sm">{review.comment}</p>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Teklif Formu */}
      <section className="bg-blue-600 px-6 py-10">
        <div className="max-w-xl mx-auto bg-white rounded-lg shadow-md border border-gray-200 p-6">
          <h3 className="text-xl font-bold mb-4 text-gray-800 text-center">{service.title} için teklif alın</h3>
          <p className="text-gray-600 mb-6 text-center">{service.full_desc}</p>
          <form className="space-y-4" onSubmit={(e) => {
            e.preventDefault();
            emailjs.sendForm(
              "service_95zhqfp",
              "template_zndy8a5",
              e.target,
              "yQ6CrqMr3xNkN1kQH"
            )
            .then(() => {
              alert("Talebiniz başarıyla gönderildi!");
              e.target.reset();
            })
            .catch((err) => {
              console.error("E-posta gönderilemedi:", err);
              alert("Bir hata oluştu. Lütfen tekrar deneyin.");
            });
          }}>
            <input type="text" name="from_name" placeholder="Ad Soyad" required className="w-full border px-4 py-2 rounded" />
            <input type="tel" name="phone" placeholder="Telefon" required className="w-full border px-4 py-2 rounded" />
            <input type="email" name="from_email" placeholder="E-posta" required className="w-full border px-4 py-2 rounded" />
            <input type="text" name="service" value={service.title} readOnly className="w-full border px-4 py-2 rounded bg-gray-100" />
            <textarea name="message" placeholder="Mesajınız" rows="4" className="w-full border px-4 py-2 rounded" />
            <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 w-full">
              Teklif Talebi Gönder
            </button>
          </form>
        </div>
      </section>

      {/* İletişim Bilgileri */}
      <section className="bg-blue-600 px-6 py-10">
        <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md border border-gray-200 p-6">
          <h3 className="text-xl font-bold mb-6 text-gray-800 text-center">İletişim Bilgileri</h3>
          <div className="grid gap-6">
            <div className="flex items-center space-x-3">
              <span className="text-3xl">📞</span>
              <div>
                <p className="text-gray-600 text-sm">Telefon</p>
                <a href="tel:05513683020" className="text-blue-900 font-bold text-lg hover:underline">
                  0551 368 30 20
                </a>
              </div>
            </div>
            <div className="flex items-center space-x-3">
                            <span className="text-3xl">💬</span>
              <div>
                <p className="text-gray-600 text-sm">WhatsApp</p>
                <a
                  href="https://wa.me/905513683020"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-900 font-bold text-lg hover:underline"
                >
                  0551 368 30 20
                </a>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <span className="text-3xl">📧</span>
              <div>
                <p className="text-gray-600 text-sm">E-posta</p>
                <a
                  href="mailto:info@elektrikuzmanı.com"
                  className="text-blue-900 font-bold text-lg hover:underline"
                >
                  info@elektrikuzmanı.com
                </a>
              </div>
            </div>

            <div className="flex items-center space-x-3">
              <span className="text-3xl">📍</span>
              <div>
                <p className="text-gray-600 text-sm">Bölge</p>
                <p className="text-blue-900 font-bold text-lg">Ankara</p>
              </div>
            </div>
          </div>

          <div className="mt-8 p-4 bg-yellow-100 rounded-lg border border-yellow-300">
            <p className="text-yellow-800 font-semibold text-center text-lg">
              ⚡ Acil Durumlarda 7/24 Hizmet
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <div className="mb-4">
            <img
              src="/logo.png"
              alt="Logo"
              className="h-16 w-auto mx-auto mb-2"
            />
            <h5 className="text-xl font-bold">Ankara Elektrik Uzmanı</h5>
          </div>
          <p className="text-gray-400 mb-2">
            📞 0551 368 30 20 | 📧 info@elektrikuzmanı.com
          </p>
          <p className="text-gray-500 text-sm mt-4">
            © 2025 Ankara Elektrik Uzmanı. Tüm hakları saklıdır.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default ServiceDetailPage;